import { gql } from "@apollo/client"
import { AuthorizationAcceptTermsInput, AuthorizationAcceptTermsPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const ACCEPT_REQUIRED_TERMS = gql`
  mutation acceptTerms($roleId: ID!) {
    acceptTerms(input: { roleId: $roleId }) {
      errors
    }
  }
`

export const useAcceptRequiredTerms = (
  options?: InjectedOptions<
    { acceptTerms: AuthorizationAcceptTermsPayload },
    AuthorizationAcceptTermsInput
  >,
) => useMutation(ACCEPT_REQUIRED_TERMS, options)
